import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { authGuard } from "../auth/authGuard";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: authGuard
  },
  {
	path: '/orders/:id',
    name: 'ViewOrder',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "vieworder" */ '../components/ViewOrder.vue'),
    beforeEnter: authGuard
  },
  {
	path: '/orders',
    name: 'Orders',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../components/Orders.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/applications',
      name: 'Applications',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( '../components/Applications.vue'),
      beforeEnter: authGuard
    },
    {
    path: '/applications/overview',
    name: 'ApplicationsOverview',
    meta: {layout: "public"},
    component: () => import( '../components/Applications/ApplicationsOverview.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/applications/overview-coaching',
    name: 'ApplicationsOverviewCoaching',
    meta: {layout: "public"},
    component: () => import( '../components/Applications/ApplicationsOverviewCoaching.vue'),
    beforeEnter: authGuard
  },
    {
      path: '/applications/status/:status',
        name: 'Applications',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( '../components/Applications.vue'),
        beforeEnter: authGuard,
        props: {
          roundId:process.env.VUE_APP_CURRENT_ROUND_ID,
          councilAreaId:'',
          governingBodyId:''
        }
      }
      ,
  {
    path: '/applications/:id',
      name: 'Applications',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( '../components/Applications/ViewApplication.vue'),
      beforeEnter: authGuard
  }  ,
  {
    path: '/applications/:id/addapplicationfunding',
      name: 'Applications',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "applications" */ '../components/Applications/AddApplicationFunding.vue'),
      beforeEnter: authGuard
  }  ,
  {
    path: '/applications/:id/print',
      name: 'PrintApplication',
      meta: {layout: "public"},
     component: () => import( '../components/Applications/PrintApplication.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/governing_bodies',
        name: 'GoverningBodies',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( '../components/GoverningBodies.vue'),
        beforeEnter: authGuard
      }
      ,
  {
    path: '/public/newapplication',
      name: 'NewApplication',
      meta: {layout: "public"},
      component: () => import( '../components/Public/NewApplication.vue'),
      /*beforeEnter: authGuard - Not needed for the public page */
    },
    {
      path: '/public/newapplicationcoaching',
        name: 'NewApplicationCoaching',
        meta: {layout: "public"},
        component: () => import( '../components/Public/NewApplicationCoaching.vue'),
        /*beforeEnter: authGuard - Not needed for the public page */
      },
    // Contacts section
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import( '../components/Contacts/Search.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/contacts/add',
    name: 'AddContact',
    component: () => import( '../components/Contacts/AddContact.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/contacts/:id/addnote',
    name: 'AddContactNote',
    component: () => import( '../components/Contacts/AddContactNote.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/contacts/:id/addapplication',
    name: 'AddContactApplication',
    component: () => import( '../components/Contacts/AddContactApplication.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/contacts/:id',
      name: 'ViewContact',
      component: () => import('../components/Contacts/ViewContact.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/contacts/:id/:tab',
        name: 'ViewContact',
        component: () => import('../components/Contacts/ViewContact.vue'),
        beforeEnter: authGuard
      },
    {
      path: '/reports/applications_by_council_area',
        name: 'CouncilAreaReport',
         component: () => import( '../components/Reports/ApplicationsByCouncilArea.vue'),
        beforeEnter: authGuard
    }  ,
    {
      path: '/reports/funded_athletes_contact_details',
        name: 'FundedAthletesReport',
         component: () => import( '../components/Reports/FundedAthletesReport.vue'),
        beforeEnter: authGuard
    }  ,
    {
      path: '/reports/athletes_breakdown',
        name: 'AthletesBreakdownReport',
         component: () => import( '../components/Reports/AthletesBreakdownReport.vue'),
        beforeEnter: authGuard
    }  ,
    {
      path: '/users',
      name: 'Users',
      component: () => import( '../components/Users/ListUsers.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/users/add',
      name: 'AddUser',
      component: () => import( '../components/Users/AddUser.vue'),
      beforeEnter: authGuard
    },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
